import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentQuestionIndex: 0,
  selectedAnswers: {},
  timeLeft: 20 * 60,
};

const practiceSlice = createSlice({
  name: 'practice',
  initialState,
  reducers: {
    setCurrentQuestionIndex: (state, action) => {
      state.currentQuestionIndex = action.payload;
    },
    setAnswer: (state, action) => {
      const { questionId, answer } = action.payload;
      state.selectedAnswers[questionId] = answer;
    },
    decrementTime: (state) => {
      if (state.timeLeft > 0) {
        state.timeLeft -= 1;
      }
    },
    resetTime: (state, action) => {
      state.timeLeft = action.payload;
    },
    clearExtraReducers  : (state) =>{
      state.currentQuestionIndex = 0
      state.selectedAnswers = {}
      state.timeLeft = 20 * 60
     },
     clearSetAnswer: (state,action) => {
      state.selectedAnswers = {}
    },
  },
});

export const { setCurrentQuestionIndex, setAnswer, decrementTime, resetTime, clearSetAnswer } = practiceSlice.actions;
export default practiceSlice.reducer;
